import { AxiosError } from 'axios';
import { GET_GROUP_RESIT_REGISTRATION_PROFILES_REGISTRATIONS } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { GET_GROUP_RESIT_REGISTRATION_PROFILES_REGISTRATIONS_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import { GroupResitTotalPayment } from '../../models/@candidate/candidateResitRegistrationSchema';
import { CandidateSubject } from './model';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
interface GroupResitAndProfilesResponse {
  candidateSummary: CandidateSummary[];
  paymentModel: GroupResitTotalPayment;
}

interface CandidateSummary extends CandidateSubject {
  candidateName: string;
  uinfin: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: GroupResitAndProfilesResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetGroupResitAndProfiles = ({ uuid, onSuccess, onError }: Input) => {
  const getGroupResitAndProfiles = async () => {
    const res = await axiosClient.get<GroupResitAndProfilesResponse>(
      GET_GROUP_RESIT_REGISTRATION_PROFILES_REGISTRATIONS(uuid)
    );
    return res.data;
  };

  return useCustomQuery(
    GET_GROUP_RESIT_REGISTRATION_PROFILES_REGISTRATIONS_KEY,
    getGroupResitAndProfiles,
    {
      onSuccess,
      onError,
    }
  );
};
